import { makeStyles } from 'tss-react/mui'

const ImpersonateStyle = makeStyles()((theme: any) => ({
  autoCompleteTextInput: {
    '& input': {
      marginTop: '-9px',
      marginBottom: '-9px',
      '&:disabled': {
        color: 'rgb(84, 84, 84)',
        backgroundColor: 'rgba(239, 239, 239, 0.3)',
        borderColor: 'rgba(118, 118, 118, 0.3)',
      },
    },
  },
}))

export default ImpersonateStyle
